import type { RefundRow } from "../types";

/** 管理列表与状态筛选共用的请款状态名称。 */
export const refundStatusLabels: Record<RefundRow["status"], string> = {
  pending: "未请款", approved: "已请款", rejected: "未退款",
};

/** 三态颜色与文字同时区分，避免仅依赖颜色。 */
export const refundStatusColors = { pending: "orange", approved: "green", rejected: "red" } as const;
